import { i18next, utils } from '@yola/ws-sdk';

const { isURL, isFullyURL } = utils.validation;
const hashRouteRegexp = /^#(?!#)[^\s]*$/;

const createExternalValidator = () => (value) => {
  if (!value) {
    return i18next.t('Invalid URL. The URL can not be empty');
  }

  const trimmedValue = value.trim();

  if (trimmedValue.startsWith('#')) {
    if (!hashRouteRegexp.test(trimmedValue)) {
      return i18next.t('Invalid URL. Please, check the URL and try again');
    }

    return null;
  }

  if (trimmedValue.startsWith('/')) {
    const tmpURL = `https://yola.com${trimmedValue}`;

    if (!isURL(tmpURL)) {
      return i18next.t('Invalid URL. Please, check the URL and try again');
    }

    return null;
  }

  if (!isFullyURL(trimmedValue)) {
    return i18next.t('Invalid URL. Please, check the URL and try again');
  }

  return null;
};

export default createExternalValidator;
